module.exports = __webpack_public_path__ + "img/xiangmin.0c71b254.jpeg";